import { render, staticRenderFns } from "./QuoteStatusDisplay.vue?vue&type=template&id=1c645ba0&"
import script from "./QuoteStatusDisplay.vue?vue&type=script&lang=ts&"
export * from "./QuoteStatusDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports